import { render, staticRenderFns } from "./ContentRegisterRoutes.vue?vue&type=template&id=73bf2c38"
import script from "./ContentRegisterRoutes.vue?vue&type=script&lang=js"
export * from "./ContentRegisterRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports